import { FunctionComponent, useRef } from 'react'
import { Calendar as CalendarProps } from './CalendarSelector.types'
import { Label } from '../primitives/Label/Label'
import { Button } from '../primitives/Button/Button'
import './CalendarSelector.scss'
import { CalendarModal } from '../CalendarModal/CalendarModal'
import { useAtom } from 'jotai'
import { calendarSelectorPopover } from 'src/atoms/modals/calendarSelectorPopover'
import { extractDateFromButton } from './utils'
import { useActions } from 'src/hooks/useActions'
import { useHomeScreenRefetch } from 'src/hooks/useHomeScreenRefetch'

export const CalendarSelector: FunctionComponent<CalendarProps> = ({
  attributes
}) => {
  const {
    date,
    subtitle,
    previousButton,
    nextButton,
    openCalendarButton
  } = attributes
  const [{ date: dateString }] = useAtom(calendarSelectorPopover)
  const parentRef = useRef<HTMLDivElement>(null)
  const { triggerRefetch } = useHomeScreenRefetch()
  const isExpress = false

  const { onClick: onClickCalendarSelector } = useActions(
    openCalendarButton?.attributes?.actions
  )

  const handlePreviousButtonClick = () => {
    const extractedDate = extractDateFromButton(previousButton)
    if (extractedDate) {
      triggerRefetch()
    }
  }

  const handleNextButtonClick = () => {
    const extractedDate = extractDateFromButton(nextButton)
    if (extractedDate) {
      triggerRefetch()
    }
  }

  const onClickCalendarSelectorHandler = (
    e: React.MouseEvent<HTMLDivElement>
  ) => {
    e.stopPropagation()
    onClickCalendarSelector()
  }

  const onKeyDownCalendarSelectorHandler = (
    e: React.KeyboardEvent<HTMLDivElement>
  ) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault()
      e.stopPropagation()
      onClickCalendarSelector()
    }
  }

  return (
    <>
      <CalendarModal date={dateString} parentRef={parentRef} />
      <div
        ref={parentRef}
        className="core-ux-calendar-selector"
        data-testid="calendar-selector">
        {previousButton && !isExpress && (
          <Button
            onClick={handlePreviousButtonClick}
            {...previousButton}
            className="core-ux-calendar-selector__button core-ux-calendar-selector__button--with-small-icon core-ux-calendar-selector__button--with-bg core-ux-calendar-selector__button--left"
          />
        )}
        <div
          data-testid="calendar-selector-content"
          className="core-ux-calendar-selector__content"
          onClick={onClickCalendarSelectorHandler}
          onKeyDown={onKeyDownCalendarSelectorHandler}
          role="button"
          tabIndex={0}
          aria-label="Open calendar selector">
          <div className="core-ux-calendar-selector__date">
            <Label {...date} />
            {openCalendarButton && !isExpress && (
              <Button
                {...openCalendarButton}
                className="core-ux-calendar-selector__button"
              />
            )}
          </div>
          <div className="core-ux-calendar-selector__subtitle-wrapper">
            <Label
              {...subtitle}
              className="core-ux-calendar-selector__subtitle"
            />
          </div>
        </div>
        {nextButton && !isExpress && (
          <Button
            onClick={handleNextButtonClick}
            {...nextButton}
            className="core-ux-calendar-selector__button core-ux-calendar-selector__button--with-small-icon core-ux-calendar-selector__button--with-bg core-ux-calendar-selector__button--right"
          />
        )}
      </div>
    </>
  )
}
